import { BMT_HUB_PATH } from '@/constants/bmt';

/**
 * beforeEnter for /bmt/check-in: the `bmt-companion` flag first, exactly as /bmt
 * is gated, then a scan result to show. A visit with none (a reload, a deep
 * link, Back after the result was cleared) goes to the hub instead.
 */
export function createBmtCheckInGuard({ requireFlag, store }) {
  return async () => {
    const blocked = await requireFlag();
    if (blocked) return blocked;
    if (!store.state.bmt?.lastCheckIn) return BMT_HUB_PATH;
    return undefined;
  };
}
